//components/signs/view/Filters.js
//UI for managing view filter conditions
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, IconButton, MenuItem, Box, MenuList, Typography} from '@material-ui/core';
import IconDelete from '@material-ui/icons/Delete';
//import Fields from './Fields';
import operators from './Operators';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow:1,
	},
  	table: {
    	minWidth: 650,
		maxHeight:'calc(100vh - 64px)',
		//maxHeight: '100%'
	},
    fieldlist : {
        minWidth: 200,
        minHeight: 300,
        maxHeight : 500,
        overflow: 'auto'
    },
    listcontrols : {
        display: 'flex',
        flexDirection : 'column',
        width: 50
    },
    optionfield : {
        width : 150
    }
}));


export default function Filters(props) {
    //inherited properties from parent
    const {view, setView, fields} = props;
    //currently selected condition
    const [selected, setSelected] = React.useState(null);
    //all available fields
    const allFields = fields();
    //added classes
    const classes = useStyles();
    //all condition operators
    const allOps = operators();


    //add a filter condition
    const handleAddFilter = (e) => {
        //get field name
        let fieldname = e.target.value;
        //get the field class
        let field = allFields.find(n => n.name === fieldname);
        //copy view
        let newView = Object.assign({}, view);
        //add condition to view filter
        newView.lv_filter.conditions.push({
            field : fieldname,
            operator : operators(field.type)[0].id,
            value : ''
        });
        //update view
        setView(newView);
    }

    //remove filter condition
    const handleRemove = (e) => {
        if(!view.lv_filter.conditions[selected]) return false;
        //copy view
        let newView = Object.assign({}, view);
        //remove from list
        newView.lv_filter.conditions.splice(selected, 1);
        //deselect
        setSelected(null);
        //update the view
        setView(newView);
    }

    //change condition attribute
    const handleChangeCondition = (e) => {
        if(!view.lv_filter.conditions[selected]) return false;
        //copy view
        let newView = Object.assign({}, view);
        //update value
        Object.assign(newView.lv_filter.conditions[selected], {
            [e.target.name] : e.target.value
        });
        //update view
        setView(newView);
    }

    //render UI for selected condition
    const filterOptions = () => {
        if(!view.lv_filter.conditions[selected]) return (<Typography>No condition selected</Typography>);
        //get the selected condition
        let filter = view.lv_filter.conditions[selected];
        //get the field attributes
        let field = allFields.find(n => n.name === filter.field);
        //get the operator of selected condition
        let operator = allOps.find(n => n.id === filter.operator);
        //render
        return (
            <Box id="filtercontrols" display="flex">
                <Box id="filtercontrol" className={classes.listcontrols}> 
                    <IconButton onClick={handleRemove}>
                        <IconDelete />
                    </IconButton>
                </Box>
                <Box id="filteroptions" className={classes.optionfield}>
                    <TextField
                        id="filter_field"
                        label="Field unique name"
                        name="field"
                        value={field.name}
                        disabled={true}
                        fullWidth
                    />
                    <TextField
                        id="filter_operator"
                        label="Condition"
                        name="operator"
                        value={filter.operator}
                        onChange={handleChangeCondition}
                        fullWidth
                        select
                    >
                        {operators(field.type).map((opr, i) => (
                        <MenuItem value={opr.id} key={i}>{opr.label}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        id="filter_value"
                        label="Compare value"
                        name="value"
                        value={filter.value}
                        onChange={handleChangeCondition}
                        disabled={operator && Boolean(operator.notcompare)}
                        fullWidth
                    />
                </Box>
            </Box>
            );
        
    }
    //text representation of filter condition
    const describeFilter = (filter, i) => {
        let operator = allOps.find(n => n.id === filter.operator);
        let field = allFields.find(n => n.name === filter.field);
        let out = [field.label, operator.name];
        if(field.type === 'BOOLEAN'){
            out =  [operator.name, field.label];
        }
        if(!Boolean(operator.notcompare)) {
            if(field.type === "VARCHAR"){
                out.push('"'+filter.value+'"');
            } else {
                out.push(filter.value);
            }
        }
        //add condition number for use in custom filter logic
        if(view.lv_filter.type === 'CUSTOM'){
            out.unshift(i+1);
        }
        return out.join(' ');
    };

    //change filter type
    const handleChangeType = (e) => {
        //copy view
        let newView = Object.assign({}, view);
        //update variable
        newView.lv_filter.type = e.target.value;
        //update view
        setView(newView);
    }

    //change filter custom logic
    const handleChangeLogic = (e) => {
        //copy view
        let newView = Object.assign({}, view);
        //update variable
        newView.lv_filter.custom = e.target.value;
        newView.errors = isLogicInvalid(e.target.value);
        //update view
        setView(newView);
    }

    //check for logical use of brackets
    const isBracketValid = (logic) => {
        let clean = logic.replace(/[^()]/g, '');
        if(!clean) return true;
        const map = new Map();
        map.set('{', '}');
        map.set('(', ')');
        map.set('[', ']');
        const b=[];
        for(let i = 0; i < clean.length; i++){
            if(map.has(clean.charAt(i))){
                b.push(clean.charAt(i));
            } else {
                let pop = b.pop();
                if(map.get(pop)!==clean.charAt(i)){
                    return false;
                }
            }
        }
        return b.length === 0;
    }

    //ensure all conditions are included
    const allFiltersUsed = (logic) => {
        //reduce to individual numbers
        let items = logic.toUpperCase().replace(/AND|OR|\(|\)/g, ' ').replace(/\s+/g, ' ').trim().split(' ').map(n => Number(n));
        return allFilterItemsUsed(items);
    }

    //compare items to conditions
    const allFilterItemsUsed = (items) => {
        //are they the same size?
        if(items.length !== view.lv_filter.conditions.length) return false;
        //are they all used
        for(let n = 0; n < view.lv_filter.conditions.length; n++){
            if(items.indexOf(n+1) === -1) return false;
        }
        return true;
    }

    //ensure theres and AND or OR between each condition identifier
    const glueCheck = (logic) => {
        //remove everything besides numbers and glue and split with glue
        let items = logic.toUpperCase().replace(/[^AND|OR|0-9]/g, '').split(/AND|OR/).map(n => Number(n));
        return allFilterItemsUsed(items);
    }

    //validate condition logic
    const isLogicInvalid = (logic) => {
        //has a value
        if(!logic) return 'Please define custom logic';
        //permitted characters: ANDOR() 0-9
        if(isNaN(logic.toUpperCase().replace(/AND|OR|\(|\)| /g, ''))) return 'contains invalid characters'
        //all open parenthesis have a close parenthesis
        if(!isBracketValid(logic)) return 'invalid use of parenthesis';
        //all conditions must be used
        if(!allFiltersUsed(logic)) return 'Please include all conditions once';
        //all conditions must have an OR or AND between them
        if(!glueCheck(logic)) return 'logic is invalid';
        return '';
    }

    //custom logic input field
    const customLogic = () => {
        if(view.lv_filter.type !== 'CUSTOM') return '';
        return (
            <TextField
                id="custom_logic"
                name="custom"
                label="Custom logic"
                value={view.lv_filter.custom || view.lv_filter.conditions.map((f, i) => i+1).join(' AND ')}
                onChange={handleChangeLogic}
                error={view.lv_filter.custom && Boolean(isLogicInvalid(view.lv_filter.custom))}
                helperText={view.lv_filter.custom ? isLogicInvalid(view.lv_filter.custom) : ''}
                fullWidth
            />


        )
    }

    //render filter conditions
    return (
        <Box id="filters">
            <Box id="filtertype">
                <TextField
                    id="filter_type"
                    name="type"
                    label="Filter logic"
                    value={view.lv_filter.type}
                    onChange={handleChangeType}
                    fullWidth
                    select
                >
                    <MenuItem key={0} value="AND">All conditions must be met (AND)</MenuItem>
                    <MenuItem key={1} value="OR">Any condition may be met (OR)</MenuItem>
                    <MenuItem key={2} value="CUSTOM">Custom logic</MenuItem>
                </TextField>
                {customLogic()}
            </Box>
            <Box id="addfilter">
                <TextField
                    id="add_filter"
                    label="Add Condition..."
                    value={null}
                    onChange={handleAddFilter}
                    fullWidth
                    select
                >
                {allFields.filter(n => n.type !== 'HIDDEN').map((field, i) => (
                    <MenuItem value={field.name} key={i}>{field.label}</MenuItem>
                ))}
                </TextField>
            </Box>
            <Box id="filtercontrol" display="flex">
                <Box id="filterlist" className={classes.fieldlist}>
                    <MenuList>
                        {view.lv_filter.conditions.map((filter, i) => (
                            <MenuItem onClick={e => setSelected(i)} value={i} selected={i === selected} key={i}>
                                {describeFilter(filter, i)}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Box>
                {filterOptions()}
            </Box>
        </Box>
    );
}
